import { InstructionCSSClasses } from '../../components/script-editor/tools/types';

type InstructionTypes = {
  nameScript: string[];
};

type InstructionBlockTypes = {
  nameScript: string;
};

class InstructionTypeGetter {
  static get(element: HTMLElement): keyof InstructionTypes | null {
    let instructionType: string | null = null;
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const typeName in this.instructionTypes) {
      if (instructionType) {
        break;
      }
      // @ts-ignore
      // eslint-disable-next-line consistent-return, no-loop-func
      this.instructionTypes[typeName].forEach((item: string) => {
        if (element.classList.contains(item)) {
          instructionType = typeName;
          // eslint-disable-next-line
          return;
        }
      });
    }

    return instructionType;
  }

  static get instructionTypes(): InstructionTypes {
    return {
      nameScript: [
        InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_WRAPPER,
        InstructionCSSClasses.NAME_SCRIPT_INSTRUCTION_BLOCK,
      ],
    };
  }

  static get instructionBlockTypes(): InstructionBlockTypes {
    return {
      nameScript: 'nameScriptInstructionBlock',
    };
  }
}

export default InstructionTypeGetter;
